import { useEffect, useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { Table } from 'reactstrap';
import { AssignProjectMilestone } from '../../../../domain/projectMilestones/assignProjectMilestone';
import { BaseSelector } from '../../../../domain/shared';
import { ProjectMilestoneRepository } from '../../../../infrastructure/repositories/projectMilestones/projectMilestoneRepository';

interface Props {
    assignMilestoneModal: AssignProjectMilestone[];
    setSelectedMilestonesModal: React.Dispatch<
        React.SetStateAction<AssignProjectMilestone[]>
    >;
}

export default function ModalAssignMilestonesSection({
    assignMilestoneModal,
    setSelectedMilestonesModal,
}: Props) {
    const [milestones, setMilestones] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const handlerChange = (e: SingleValue<BaseSelector>) => {
        const selectedWeight = 0;
        const totalWeight = assignMilestoneModal.reduce(
            (acc, curr) => acc + curr.weight,
            0
        );

        if (totalWeight + selectedWeight <= 100) {
            console.log(totalWeight);
            console.log(selectedWeight);
            let existMileStone = assignMilestoneModal.filter(
                (st) => st.projectMilestoneId === Number(e?.value)
            );

            if (existMileStone.length === 0) {
                if (e && e.value !== '') {
                    const newMilestone: AssignProjectMilestone = {
                        projectMilestoneId: Number(e.value),
                        plannedPercentage: 0,
                        percentageRealized: 0,
                        weight: selectedWeight,
                    };

                    setSelectedMilestonesModal([
                        ...assignMilestoneModal,
                        newMilestone,
                    ]);
                }
            }
        } else {
            console.log('La suma de los pesos de los hitos excede el 100%');
        }
    };

    const onChangeMileStone = (
        index: number,
        value: string | number,
        name: string
    ) => {
        const numericValue = parseFloat(value.toString());

        if (name === 'weight') {
            const totalWeight = assignMilestoneModal.reduce(
                (acc, curr, i) =>
                    i === index ? acc + numericValue : acc + curr.weight,
                0
            );

            if (totalWeight <= 100) {
                setSelectedMilestonesModal(
                    assignMilestoneModal.map((st, i) => {
                        if (i === index) {
                            return {
                                ...st,
                                [name]: numericValue,
                            };
                        }
                        return st;
                    })
                );
                setErrorMessage('');
            } else {
                setErrorMessage('La suma de los pesos de los hitos excede el 100%');
                setTimeout(() => {
                    setErrorMessage('');
                }, 5000);
            }
        } else {
            if (numericValue <= 100) {
                setSelectedMilestonesModal(
                    assignMilestoneModal.map((st, i) => {
                        if (i === index) {
                            return {
                                ...st,
                                [name]: numericValue,
                            };
                        }
                        return st;
                    })
                );
            } else {
                setErrorMessage(`El valor no puede ser mayor que 100%`);
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            }
        }
    };

    const handleInputKeyPress = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number,
        name: string
    ) => {
        if (e.key === 'Enter') {
            const inputValue = e.currentTarget.value;
            onChangeMileStone(index, inputValue, name);
        }
    };

    useEffect(() => {
        setIsLoading(true);

        ProjectMilestoneRepository.GetMilestonesList().then((res) => {
            setIsLoading(false);

            setMilestones(
                res.map((dt) => ({
                    label: dt.name,
                    value: dt.id,
                }))
            );
        });
    }, []);

    const handlerRemove = (e: number) => {
        let milestoneFilteredList = assignMilestoneModal.filter(
            (st) => st.projectMilestoneId !== e
        );

        setSelectedMilestonesModal(milestoneFilteredList);
    };

    return (
        <div className=''>
            {errorMessage && (
                <div className='text-danger mb-2 bg-soft-danger p-1 px-2 w-50 rounded'>
                    {errorMessage}
                </div>
            )}
            <div className='col-11'>
                <div>
                    <Select
                        className=' '
                        classNamePrefix='select'
                        isLoading={isLoading}
                        isSearchable={true}
                        placeholder='Seleccione'
                        name='color'
                        options={milestones}
                        onChange={(c) => handlerChange(c)}
                        isClearable={true}
                    />
                </div>
            </div>

            <div className='col-12 mt-5 '>
                <h4>Hitos Seleccionados</h4>
                <Table>
                    <thead>
                        <tr>
                            <th scope='col'>Nombre</th>
                            <th style={{ textAlign: 'center' }} scope='col'>
                                Peso
                            </th>
                            <th style={{ textAlign: 'center' }} scope='col'>
                                Porcentaje Planeado
                            </th>
                            <th style={{ textAlign: 'center' }} scope='col'>
                                Porcentaje Realizado
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className='table-group-divider'>
                        {assignMilestoneModal.map((selectedMilestone, index) => (
                            <tr key={index}>
                                <td>
                                    {
                                        milestones.find(
                                            (ms) =>
                                                ms.value ===
                                                selectedMilestone.projectMilestoneId
                                        )?.label
                                    }
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <input
                                        type='number'
                                        value={selectedMilestone.weight}
                                        onChange={(e) => {
                                            onChangeMileStone(
                                                index,
                                                e.target.value,
                                                'weight'
                                            );
                                        }}
                                        onKeyDown={(e) =>
                                            handleInputKeyPress(e, index, 'weight')
                                        }
                                        max={100}
                                    />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <input
                                        type='number'
                                        value={selectedMilestone.plannedPercentage}
                                        onChange={(e) => {
                                            onChangeMileStone(
                                                index,
                                                e.target.value,
                                                'plannedPercentage'
                                            );
                                        }}
                                        max={100}
                                    />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <input
                                        type='number'
                                        value={selectedMilestone.percentageRealized}
                                        onChange={(e) => {
                                            onChangeMileStone(
                                                index,
                                                e.target.value,
                                                'percentageRealized'
                                            );
                                        }}
                                        max={100}
                                    />
                                </td>
                                <td
                                    onClick={() =>
                                        handlerRemove(
                                            selectedMilestone.projectMilestoneId
                                        )
                                    }
                                >
                                    <i className='ri-delete-bin-5-line fs-20 text-muted'></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}
